const reportsPage = {
  report: 'Relatórios',
};

export default reportsPage;
